const elements = {
  tabs: [...document.body.querySelectorAll('.js-tabs')],
};

const settings = {
  tabCssClass: 'js-tabs__tab',
};

function calcIndex(index, keyCode) {
  const calc = {
    37: (index - 1), // Left
    39: (index + 1), // Right
  };

  return calc[keyCode];
}

function pushHistory(el) {
  window.history.pushState({}, null, `${window.location.pathname}#${el.getAttribute('id')}`);
}

function toggleVisibility(e, index) {
  const tabs = [...this.querySelectorAll(`.${settings.tabCssClass}`)];
  const panels = [...this.querySelectorAll('.js-tabs__tabpanel')];
  const activeCss = 'is-active';

  tabs.forEach((el, i) => {
    el.classList.remove(activeCss);
    el.setAttribute('aria-selected', false);
    el.setAttribute('tabindex', -1);

    if (i === index) {
      el.classList.add(activeCss);
      el.setAttribute('aria-selected', true);
      el.setAttribute('tabindex', 0);
      el.focus();
    }
  });

  panels.forEach((el, i) => {
    el.setAttribute('hidden', '');

    if (i === index) {
      el.removeAttribute('hidden');
    }
  });

  pushHistory(panels[index]);
}

function keyHandler(e) {
  if (e.target.classList.contains(settings.tabCssClass)) {
    const index = parseInt(e.target.dataset.index, 10);

    if ((e.keyCode === 37 && index > 0) ||
      (e.keyCode === 39 && index < parseInt(this.dataset.count - 1, 10))) {
      e.preventDefault();
      const boundToggleVisibility = toggleVisibility.bind(this, e, calcIndex(index, e.keyCode));
      boundToggleVisibility();
    }
  }
}

function clickHandler(e) {
  if (e.target.classList.contains(settings.tabCssClass) && !e.target.classList.contains('is-active')) {
    const index = parseInt(e.target.dataset.index, 10);
    const boundToggleVisibility = toggleVisibility.bind(this, e, index);
    boundToggleVisibility();
  }
}

function checkHash() {
  if (window.location.hash !== '') {
    const tab = document.querySelector(window.location.hash);
    const container = tab.closest('.js-tabs');
    const index = parseInt(tab.dataset.index, 10);
    const boundToggleVisibility = toggleVisibility.bind(container, null, index);
    boundToggleVisibility();
  }
}

function init() {
  if (elements.tabs.length) {
    checkHash();

    elements.tabs.forEach((el) => {
      el.addEventListener('click', clickHandler);
      el.addEventListener('keydown', keyHandler);
    });
  }
}

export default init;


// WEBPACK FOOTER //
// ./src/components/components/searches/tabs/mando-ui.tabs.js